<template>
    <div> 


     <el-tabs @tab-click="handleTabs">
        <el-tab-pane label="教师请假"></el-tab-pane>
        <el-tab-pane label="职能岗请假"></el-tab-pane>
        <el-tab-pane label="调休"></el-tab-pane>
     </el-tabs>

      <el-form class="select" style="display: flex; flex-wrap: wrap;">

            <el-form-item  label="提交时间" label-width="100px" style="width: 40%;text-align: justify;">
              <el-date-picker size="small"  v-model="dateTimeList"   type="daterange"  style="width: 100%;"   value-format="yyyy-MM-dd"   range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期">   </el-date-picker>
            </el-form-item>

            <el-form-item  label="完成时间" label-width="100px" style="width: 40%;text-align: justify;">
              <el-date-picker  size="small" v-model="dateTimeList1"   type="daterange"  style="width: 100%;"   value-format="yyyy-MM-dd"   range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期">   </el-date-picker>
            </el-form-item>

            <el-form-item label="审批状态:" label-width="100px" style="width: 30%;" >
              <el-select size="small" v-model="courseType"  filterable placeholder="全部"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in courseTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="部门:" label-width="100px" style="width: 40%;" >
               <el-select size="small"  v-model="courseType1"  placeholder="请选择部门" style="width: 100%"  clearable  filterable  ref="selectTree" >
                  <el-option :value="courseType1" style="height: auto; padding: 0" >
                    <el-tree  :data="courseTypeList1" :props="{ label: 'name', value: 'id', children: 'children' }" node-key="id" :expand-on-click-node="false"  @node-click="handleNodeClick"/>
                  </el-option>
               </el-select>
            </el-form-item>

            <el-form-item label="申请人:" label-width="100px" style="width: 30%;" >
              <el-select  size="small" v-model="courseTypeinput"  filterable placeholder="请选择申请人"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in courseTypeList11"  :key="teacher.wecomUserid"   :label="teacher.name"  :value="teacher.wecomUserid"  > </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="审批编号:" label-width="100px" style="width: 30%;">
              <el-input size="small" v-model="courseTypeinput1"  placeholder="请输入审批编号"  style="width: 100%" clearable > </el-input>
            </el-form-item>

            <el-form-item  v-if="isIndex != '2'" label="请假时间" label-width="100px" style="width: 40%;text-align: justify;">
              <el-date-picker size="small" v-model="dateTimeList2"   type="daterange"  style="width: 100%;"   value-format="yyyy-MM-dd"   range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期">   </el-date-picker>
            </el-form-item>

             <el-form-item v-if="isIndex != '2'" label="请假类型:" label-width="100px" style="width: 30%;" >
              <el-select size="small" v-model="courseType2"  filterable placeholder="全部"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in courseTypeList2"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>

        </el-form>


        <div style=" padding: 10px; display: flex; justify-content: space-between;">
          <h4 style="margin-left: 20px;">共 {{ sumTop }} 条申请记录</h4>
          <div>
            <el-button type="primary" @click="handleClear" icon="el-icon-close" size="small" class="btns">清除</el-button>
            <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
            <el-button type="primary" icon="el-icon-download" size="small" class="btns" @click="handleDownload">导出记录</el-button>
            <!-- <el-button type="primary" icon="el-icon-download" size="small" class="btns" @click="handleDownloadLink">下载附件</el-button> -->
          </div>
        </div>


        <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataTableList" border height="700" v-if="isIndex === '2' || isIndex === 2">
            <el-table-column prop="spNo" header-align="center"  label="审批编号" ></el-table-column>
            <el-table-column prop="originalDate" header-align="center"  label="原请假" ></el-table-column>
            <el-table-column prop="newDate" header-align="center"  label="现请假" ></el-table-column>
            <el-table-column prop="submitTime" header-align="center"  label="提交时间" >
              <template slot-scope="scope">
                <div>{{ scope.row.submitTime }} </div>
              </template>
            </el-table-column>
            <el-table-column prop="finishTime" header-align="center"  label="完成时间" ></el-table-column>
            <el-table-column header-align="center"  label="申请人和部门" >
              <template slot-scope="scope">
                <div>{{ scope.row.userName }} </div>
                <div style="color: #b1b1b1;">{{ scope.row.departmentName }} </div> 
              </template>
            </el-table-column>
            <el-table-column prop="status" header-align="center"  label="审批状态" ></el-table-column>
            <el-table-column header-align="center" label="操作" width="150px">
              <template slot-scope="scope">
                <el-button type="text" @click="details(scope.row)">详情</el-button>
              </template>
            </el-table-column>
         </el-table>


         <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataTableList" border height="700" v-else>
            <el-table-column prop="spNo" header-align="center"  label="审批编号" ></el-table-column>
            <el-table-column prop="submitTime" header-align="center"  label="提交时间" ></el-table-column>
            <el-table-column prop="finishTime" header-align="center"  label="完成时间" ></el-table-column>
            <el-table-column header-align="center"  label="申请人和部门" >
              <template slot-scope="scope">
                <div>{{ scope.row.userName }} </div>
                <div style="color: #b1b1b1;">{{ scope.row.departmentName }} </div>
              </template>
            </el-table-column>
            <el-table-column prop="leaveType" header-align="center"  label="请假类型"></el-table-column>
            <el-table-column header-align="center"  label="请假时间" >
              <template slot-scope="scope">
                <div>{{ scope.row.startTime }} </div>
                <div>{{ scope.row.endTime }} </div>
              </template>
            </el-table-column>
            <el-table-column prop="duration" header-align="center"  label="请假时长"></el-table-column>
            <el-table-column prop="status" header-align="center"  label="审批状态" ></el-table-column>
            <el-table-column header-align="center" label="操作" width="150px">
              <template slot-scope="scope">
                <el-button type="text" @click="details(scope.row)">详情</el-button>
              </template>
            </el-table-column>
         </el-table>
      

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"  :current-page="pageNum" :page-size="pageSize"  
            layout="prev, pager, next,sizes, jumper" :total="total">
        </el-pagination>


        <el-dialog width="50%" :visible.sync="showPopUpNotification" center :title=" titles + currtnent" :before-close="showPopUpNotificationCler" :close-on-click-modal="false" modal-append-to-body :append-to-body="true">


              <div style="margin: 20px;display: flex">
                 <img  @click="createHeart(titles,$event)" src="http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/default.png" style="width: 50px; height: 50px;border-radius: 10px;" alt=""></img>
                 <span style="font-weight: 900;font-size: 20px; margin-top: 10px;  margin-left: 10px;  margin-right: 10px;">{{ titles}}{{ currtnent }}</span>
                 <span v-if="rowData.status === '审批中'" style="color: #fff; border: 1px solid #ebebeb;  background: #1278e5;  width: 50px;  height: 22px;  margin-top: 13px;  padding-left: 8px;  border-radius: 10px; ">{{ rowData.status }}</span>
                 <span v-if="rowData.status === '已通过'" style="color: #fff; border: 1px solid #ebebeb;  background: #12e538;  width: 50px;  height: 22px;  margin-top: 13px;  padding-left: 8px;  border-radius: 10px; ">{{ rowData.status }}</span>
                 <span v-if="rowData.status === '已驳回'" style="color: #fff; border: 1px solid #ebebeb;  background: #e91212;  width: 50px;  height: 22px;  margin-top: 13px;  padding-left: 8px;  border-radius: 10px; ">{{ rowData.status }}</span>
                 <span v-if="rowData.status === '已撤销'" style="color: #fff; border: 1px solid #ebebeb;  background: #e5b012;  width: 50px;  height: 22px;  margin-top: 13px;  padding-left: 8px;  border-radius: 10px; ">{{ rowData.status }}</span>
                 <span v-if="rowData.status === '通过后撤销'" style="color: #fff; border: 1px solid #ebebeb;  background: #e1be37;  width: 50px;  height: 22px;  margin-top: 13px;  padding-left: 8px;  border-radius: 10px; ">{{ rowData.status }}</span>
              </div>

              <div style="margin: 20px;">
                <span>审批编号：</span>
                <span>{{ rowData.spNo }}</span>
              </div>

              <div style="margin: 20px;">
                <span>提交时间：</span>
                <span>{{ rowData.submitTime }}</span>
              </div>

              <div style="margin: 20px;">
                <span>申请人部门：</span>
                <span>{{ rowData.departmentName }}</span>
              </div>

              <div style="margin: 20px;" v-if="isIndex != '2'">
                <span>请假类型：</span>
                <span>{{ rowData.leaveType }}</span>
              </div>

              <div style="margin: 20px;" v-if="isIndex != '2'">
                <span>开始时间：</span>
                <span>{{ rowData.leaveStartTime }}</span>
              </div>

              <div style="margin: 20px;" v-if="isIndex != '2'">
                <span>结束时间：</span>
                <span>{{ rowData.leaveEndTime }}</span>
              </div>


              <div style="margin: 20px;" v-if="isIndex != '2'">
                <span>请假时长：</span>
                <span>{{ rowData.leaveDuration }}</span>
              </div>


              <div style="margin: 20px;" v-if="isIndex != '2'">
                <span>请假事由：</span>
                <span>{{ rowData.leaveReason }}</span>
              </div>


              <div style="margin: 20px;" v-if="isIndex === '0'">
                <span>最終课程调整情况：</span>
                <span>{{ rowData.courseAdjustment }}</span>
              </div>


              <div style="margin: 20px;" v-if="isIndex === '1'">
                <span>工作交接安排说明：</span>
                <span>{{ rowData.workHandover }}</span>
              </div>

              <div style="margin: 20px;" v-if="isIndex === '2'">
                <span>原休假日期：</span>
                <span>{{ rowData.originalDate }}</span>
              </div>

              <div style="margin: 20px;" v-if="isIndex === '2'">
                <span>开始时间：</span>
                <span>{{ rowData.originalStart }}</span>
              </div>

              <div style="margin: 20px;" v-if="isIndex === '2'">
                <span>结束时间：</span>
                <span>{{ rowData.originalEnd }}</span>
              </div>

              <div style="margin: 20px;" v-if="isIndex === '2'">
                <span>原时长：</span>
                <span>{{ rowData.originalDuration }}</span>
              </div>
              
              <div style="margin: 20px;" v-if="isIndex === '2'">
                <span>现休假日期：</span>
                <span>{{ rowData.newDate }}</span>
              </div>

              <div style="margin: 20px;" v-if="isIndex === '2'">
                <span>开始时间：</span>
                <span>{{ rowData.newStart }}</span>
              </div>

              <div style="margin: 20px;" v-if="isIndex === '2'">
                <span>结束时间：</span>
                <span>{{ rowData.newEnd }}</span>
              </div>

              <div style="margin: 20px;" v-if="isIndex === '2'">
                <span>现时长：</span>
                <span>{{ rowData.newDuration }}</span>
              </div>

              <div style="margin: 20px;" v-if="isIndex === '2'">
                <span>调休事由：</span>
                <span>{{ rowData.compensateReason }}</span>
              </div>

              <div style="margin: 20px;" v-if="isIndex === '2'">
                <span>工作安排说明：</span>
                <span>{{ rowData.workArrangement }}</span>
              </div>


              <el-divider></el-divider>
              <div style="font-weight: 900;">审批流程</div>
              <el-divider></el-divider>



              <div>
                  <el-timeline>
                    <el-timeline-item  v-for="(activity, index) in activities"   :key="index"  icon="el-icon-s-custom"  type="primary">
                      <div v-if="activity.type == 1">
                        <div style=" font-weight: 900;  margin-bottom: 16px;"> {{activity.content}} </div>
                        <div style="display: flex;">
                            <img  @click="createHeart(activity.name,$event)" :src="activity.url" style="width: 30px; height: 30px;border-radius: 10px;" alt=""></img>
                            <div style="margin: 0px 10px; margin-top: 4px;"> {{activity.name}} </div>
                            <div style="  position: absolute;  right: 0;"> {{activity.timestamp}} </div>
                        </div>
                        <div style="margin-top: 10px;"> {{activity.ramk}} </div>
                      </div>
                      <div v-if="activity.type == 2">
                        <div style=" font-weight: 900;  margin-bottom: 16px;"> {{activity.content}} </div>
                        <div v-for="(itmes, indexs) in activity.list" :key="indexs"  style="margin: 10px 0px;">
                            <div style="width: 100%;  display: flex;">
                              <img   @click="createHeart(itmes.name,$event)" :src="itmes.url" style="width: 30px; height: 30px;border-radius: 10px;" alt=""></img>
                              <div style="margin: 0px 10px; margin-top: 4px;"> {{itmes.name}} </div>
                              <div style="  position: absolute;  right: 0;"> {{itmes.timestamp}} </div>
                            </div>
                        </div>
                      </div>
                    </el-timeline-item>
                  </el-timeline>
              </div>



        </el-dialog>



       
        
    </div>
</template>


<script>

  import Elupload from "./Elupload.vue";
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import loadingUtils from "../utils/loading";

  export default { 
   
    data(){
      return{

        activities: [],

        dateTimeList: [],
        dateTimeList1: [],
        dateTimeList2: [],

        courseType: '',
        courseType1: '',
        courseType1id: '',
        courseType2: '',

        courseTypeinput: '',
        courseTypeinput1: '',
          


        courseTypeList:[
          { id: 1, name:'审批中',  },
          { id: 2, name:'已通过',  },
          { id: 3, name:'已驳回',  },
          { id: 4, name:'已撤销',  },
          { id: 6, name:'通过后撤销',  },
        ],
        courseTypeList1:[],
        courseTypeList11:[],
        courseTypeList2:[
          { id: '年假', name:'年假',  },
          { id: '事假', name:'事假',  },
          { id: '病假', name:'病假',  },
          { id: '婚假', name:'婚假',  },
          { id: '产假', name:'产假',  },
          { id: '丧假', name:'丧假',  },
          { id: '调休', name:'调休',  },
        ],

        sumTop: 0,

        dataTableList: [],

        pageSize: 10,
        pageNum: 1,
        total: 0,


        showPopUpNotification: false,
        titles: '',


        isIndex: '0',


        rowData: {
          "spNo": "",  // 审批单号
          "status": "",  // 审批状态
          "submitUserId": "",  // 提交人企微id
          "submitUserName": "",  // 提交人姓名
          "submitTime": "",  // 提交时间
          "departmentName": "",  // 提交人部门
          "leaveType": "",  // 请假类型
          "leaveStartTime": '',  // 请假开始时间
          "leaveEndTime": '',  // 请假结束时间
          "leaveDuration": '',  // 请假时长
          "leaveReason": '',  // 请假事由
          "courseAdjustment": '',  // 课程调整
          "workHandover": '',  // 工作交接安排
          "originalDate": "",  // 调休 原休假日期
          "originalStart": "",  // 调休 原休假开始时间
          "originalEnd": "",  // 调休 原休假结束时间
          "originalDuration": "",  // 调休 原时长（天）
          "newDate": "",  // 调休 现休假日期
          "newStart": "",  // 调休 现休假开始时间
          "newEnd": "",  // 调休 现休假结束时间
          "newDuration": "",  // 调休 现时长（天）
          "compensateReason": "",  // 调休事由
          "workArrangement": "",  // 工作安排说明
        },
        currtnent:'',

        ccList: [],
        processesList: [],

      }
    },

    mounted(){
      this.handleGetSelectAll()
      this.getDataTableList('teacher_leave');
    },

    methods:{

      handleNodeClick(data) {
        this.courseType1 = data.name;
        this.courseType1id = data.id;
        this.$refs.selectTree.blur();
      },

      handleGetSelectAll(){
         axios.get(`${apiBaseUrl}/attendanceWXTeacher/getDepartment`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
            this.courseTypeList1 = res.data.data;
         }).catch(error => {
            this.$message.error(error)
         })
         axios.get(`${apiBaseUrl}/attendanceWXTeacher/getUserList`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
            this.courseTypeList11 = res.data.data;
         }).catch(error => {
            this.$message.error(error)
         })
      },

      handleTabs(tab) {
        let { index } = tab;
        this.pageNum = 1;
        this.pageSize = 10;
        console.log(index)
        if( index === '2' || index === 2){
           this.isIndex = index
           this.getDataTableList('compensate')
        }
        else if(index === '1' || index === 1){
          this.isIndex = index
          this.getDataTableList('staff_leave')
        }
        else{
          this.isIndex = index
          this.getDataTableList('teacher_leave')
        }
      },

      createHeart(name,event) {
        const colors = ['#ff0000', '#ff69b4', '#ff1493', '#ff00ff', '#ff4500', '#ffa500', '#ffff00', '#00ff00', '#00ffff', '#0000ff'];
        const heartCount = 12;
        
        // 创建名字元素
        const nameElement = document.createElement('div');
        nameElement.className = 'teacher-name';
        nameElement.textContent = name || '老师'; // 如果没有名字则显示"老师"
        
        // 设置名字位置
        nameElement.style.left = event.clientX + 'px';
        nameElement.style.top = (event.clientY - 30) + 'px'; // 在点击位置上方显示
        
        // 添加到页面
        document.body.appendChild(nameElement);
        
        // 1秒后移除名字
        setTimeout(() => {
          nameElement.remove();
        }, 1000);
        
        // 创建爱心
        for (let i = 0; i < heartCount; i++) {
          const heart = document.createElement('div');
          heart.className = 'heart';
          
          // 随机颜色
          const color = colors[Math.floor(Math.random() * colors.length)];
          heart.style.setProperty('--heart-color', color);
          
          // 获取点击位置
          const x = event.clientX;
          const y = event.clientY;
          
          // 设置爱心初始位置
          heart.style.left = x + 'px';
          heart.style.top = y + 'px';
          
          // 随机角度和距离
          const angle = (360 / heartCount) * i;
          const distance = 50 + Math.random() * 50;
          heart.style.setProperty('--angle', angle + 'deg');
          heart.style.setProperty('--distance', distance + 'px');
          
          // 随机大小
          const size = 10 + Math.random() * 10;
          heart.style.width = size + 'px';
          heart.style.height = size + 'px';
          
          // 添加到页面
          document.body.appendChild(heart);
          
          // 动画结束后移除元素
          setTimeout(() => {
            heart.remove();
          }, 1000);
        }
      },

      
      showPopUpNotificationCler(){
        this.titles = ''
        this.currtnent = ''
        this.ccList = []
        this.processesList = []
        this.rowData = {
          "spNo": "",  // 审批单号
          "status": "",  // 审批状态
          "submitUserId": "",  // 提交人企微id
          "submitUserName": "",  // 提交人姓名
          "submitTime": "",  // 提交时间
          "departmentName": "",  // 提交人部门
          "leaveType": "",  // 请假类型
          "leaveStartTime": '',  // 请假开始时间
          "leaveEndTime": '',  // 请假结束时间
          "leaveDuration": '',  // 请假时长
          "leaveReason": '',  // 请假事由
          "courseAdjustment": '',  // 课程调整
          "workHandover": '',  // 工作交接安排
          "originalDate": "",  // 调休 原休假日期
          "originalStart": "",  // 调休 原休假开始时间
          "originalEnd": "",  // 调休 原休假结束时间
          "originalDuration": "",  // 调休 原时长（天）
          "newDate": "",  // 调休 现休假日期
          "newStart": "",  // 调休 现休假开始时间
          "newEnd": "",  // 调休 现休假结束时间
          "newDuration": "",  // 调休 现时长（天）
          "compensateReason": "",  // 调休事由
          "workArrangement": "",  // 工作安排说明
        }
        this.showPopUpNotification = false;
      },

      handleSizeChange(val) {
        this.pageSize = val;
        this.getDataTableList();
      },

      handleCurrentChange(val) {
        this.pageNum = val;
        this.getDataTableList();
      },

      handleClear(){

          this.dateTimeList = []
          this.dateTimeList1 = []
          this.dateTimeList2 = []

          this.courseType = ''
          this.courseType1 = ''
          this.courseType1id = ''
          this.courseType2 = ''

          this.courseTypeinput = ''
          this.courseTypeinput1 = ''

          this.getDataTableList();

      },

      getDataTableList(){
        let type = this.isIndex === '1' ? 'staff_leave' : this.isIndex === '2' ? 'compensate' : 'teacher_leave'
        let data = {
            "pageNum": this.pageNum,  // 当前页数
            "pageSize": this.pageSize,  // 每页条数
            "approvalType": type,  // 假勤类型 teacher_leave：教师请假  staff_leave：职能岗位请假 compensate：调休
            "status": this.courseType ? this.courseType : null,     // 审批状态 1:审批中 2:已通过 3:已驳回 4:已撤销 6:通过后撤销
            "startTime": this.dateTimeList2 && this.dateTimeList2.length > 0 ? this.dateTimeList2[0] + ' 00:00:00' : '',  // 请假开始时间 
            "endTime": this.dateTimeList2 && this.dateTimeList2.length > 0 ? this.dateTimeList2[1] + ' 23:59:59' : '',  // 请假结束时间
            "submitStartTime": this.dateTimeList && this.dateTimeList.length > 0 ? this.dateTimeList[0] + ' 00:00:00': '',  // 提交开始时间 
            "submitEndTime": this.dateTimeList && this.dateTimeList.length > 0 ? this.dateTimeList[1] + ' 23:59:59': '',  // 提交结束时间
            "spNo": this.courseTypeinput1,  // 审批单号
            "submitUserid": this.courseTypeinput,  // 提交人企微id 
            "leaveType": this.courseType2,  // 请假类型 年假 事假 病假 婚假 产假 丧假
            "finishStartTime": this.dateTimeList1 && this.dateTimeList1.length > 0 ? this.dateTimeList1[0] + ' 00:00:00': '',  // 审批完成开始时间
            "finishEndTime": this.dateTimeList1 && this.dateTimeList1.length > 0 ? this.dateTimeList1[1] + ' 23:59:59': '',  // 审批完成结束时间
            "departmentId": this.courseType1id ? this.courseType1id : null, // 企微部门id
        }
        axios.post(`${apiBaseUrl}/attendanceWXTeacher/getAttendance`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
          if (res.data.code === 200) {
              let data = res.data && res.data.data
              this.dataTableList = data.entity
              this.total = data.allTotal ? data.allTotal : 0
              this.sumTop = data.allTotal ? data.allTotal : 0
              if(data.entity && data.entity.length < 0){
                this.dataTableList = []
              }
              this.$message({ message:res.data.message, type: "success" });
          } else {
            this.$message.error(res.data.message)
            this.dataTableList = []
          }
        }).catch((err) => {
          this.dataTableList = []
          this.$message.error(err)
        })
      },

      handleSearch(){
        this.getDataTableList();
      },

      handleDownload(){
        let url = '/attendanceWXTeacher/exportAttendance'
        let xlsxName = this.isIndex === '1' ? '职能岗请假' : this.isIndex === '2' ? '调休' : '教师请假'
        let type = this.isIndex === '1' ? 'staff_leave' : this.isIndex === '2' ? 'compensate' : 'teacher_leave'
        let data = {
            "pageNum": this.pageNum,  // 当前页数
            "pageSize": this.pageSize,  // 每页条数
            "approvalType": type,  // 假勤类型 teacher_leave：教师请假  staff_leave：职能岗位请假 compensate：调休
            "status": this.courseType ? this.courseType : null,     // 审批状态 1:审批中 2:已通过 3:已驳回 4:已撤销 6:通过后撤销
            "startTime": this.dateTimeList2 && this.dateTimeList2.length > 0 ? this.dateTimeList2[0] + ' 00:00:00' : '',  // 请假开始时间 
            "endTime": this.dateTimeList2 && this.dateTimeList2.length > 0 ? this.dateTimeList2[1] + ' 23:59:59' : '',  // 请假结束时间
            "submitStartTime": this.dateTimeList && this.dateTimeList.length > 0 ? this.dateTimeList[0] + ' 00:00:00': '',  // 提交开始时间 
            "submitEndTime": this.dateTimeList && this.dateTimeList.length > 0 ? this.dateTimeList[1] + ' 23:59:59': '',  // 提交结束时间
            "spNo": this.courseTypeinput1,  // 审批单号
            "submitUserid": this.courseTypeinput,  // 提交人企微id 
            "leaveType": this.courseType2,  // 请假类型 年假 事假 病假 婚假 产假 丧假
            "finishStartTime": this.dateTimeList1 && this.dateTimeList1.length > 0 ? this.dateTimeList1[0] + ' 00:00:00': '',  // 审批完成开始时间
            "finishEndTime": this.dateTimeList1 && this.dateTimeList1.length > 0 ? this.dateTimeList1[1] + ' 23:59:59': '',  // 审批完成结束时间
            "departmentId": this.courseType1id ? this.courseType1id : null, // 企微部门id
        }
        axios.post(`${apiBaseUrl}${url}`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((response) => {
          const blob = new Blob([response.data], { type: "application/vnd.ms-excel"})
          const downloadLink = document.createElement("a")
          downloadLink.href = URL.createObjectURL(blob)
          downloadLink.download =  '请假管理-' + xlsxName + ".xlsx"
          downloadLink.click()
        }).catch((error) => {
          this.$message.error(error)
        })
      },

      handleDownloadLink(){
        let url = ''
        let xlsxName = ''
        let data = {}
        axios.post(`${apiBaseUrl}${url}`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((response) => {
          const blob = new Blob([response.data], { type: "application/vnd.ms-excel"})
          const downloadLink = document.createElement("a")
          downloadLink.href = URL.createObjectURL(blob)
          downloadLink.download =  '请假管理' + xlsxName + ".xlsx"
          downloadLink.click()
        }).catch((error) => {
          this.$message.error(error)
        })
      },

      handleToString(num){
        let arr1 = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
        let arr2 = ["", "十", "百", "千", "万", "亿"];
        if (!num || isNaN(num)) {
            return "零";
        }
        let str = num.toString(); // 转成字符串
        let len = str.length - 1; // 获取字符串长度
        let arr = [];
        for (let i = len; i >= 0; i--) {
            let n = str[len - i]; // 取出单个数字
            let m = len - i + 1; // 取出数字对应的权重
            let s = "";
            let p = m / 4;
            let q = m % 4;
            if (q == 0 && p > 0) {
                s = arr2[4 * (p - 1)];
            }
            if (q > 0) {
                s = arr1[n] + arr2[q - 1];
            }
                arr.push(s);
        }
        return arr.reverse().join("");
      },

      details(row){
        this.titles = row.userName
        this.currtnent = this.isIndex === '1' ? '的职能岗请假详情' : this.isIndex === '2' ? '的调休详情' : '的教师请假详情'
        let data = { }
        axios.post(`${apiBaseUrl}/attendanceWXTeacher/getAttendanceDetail?spNo=${row.spNo}`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
          if (res.data.code === 200) {
              let data = res.data && res.data.data
              this.rowData = data
              this.activities = []

              this.processesList = (data.processes || []).sort((a, b) => a.step - b.step)
              this.ccList = data.ccList

              this.processesList.forEach((item,index) => {
                  this.activities.push({
                    content: `第${this.handleToString(index + 1)}级审批 . ${item.status}`,
                    url: item.avatar || 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/default.png',
                    name: item.approverName,
                    timestamp: item.approveTime,
                    ramk: item.opinion || '',
                    type: 1
                  })
              })

              if (this.ccList && this.ccList.length > 0) {
                  this.activities.push({
                    content: this.ccList[0].ccTime ? '抄送人 . 已抄送' : '抄送人 .待抄送',
                    type: 2,
                    list: this.ccList.map(item => ({
                        url: item.avatar || 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/default.png',
                        name: item.ccName,
                        timestamp: item.ccTime
                    }))
                  })
              }

              this.showPopUpNotification = true;
          } else {
            this.$message.error(res.data.message)
            this.ccList = []
            this.processesList = []
          }
        }).catch((err) => {
          this.ccList = []
          this.processesList = []
          this.$message.error(err)
        })
      },


    },



  }

</script>


<style >

.heart {
  position: fixed;
  width: 15px;
  height: 15px;
  background: var(--heart-color);
  transform: rotate(45deg);
  animation: heartExplode 1s ease-out forwards;
  z-index: 9999;
}

.heart::before,
.heart::after {
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  background: var(--heart-color);
  border-radius: 50%;
}

.heart::before {
  top: -50%;
  left: 0;
}

.heart::after {
  left: -50%;
  top: 0;
}

.teacher-name {
  position: fixed;
  color: #333;
  font-size: 14px;
  font-weight: bold;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  z-index: 10000;
  animation: nameFloat 1s ease-out forwards;
  pointer-events: none;
  white-space: nowrap;
}

@keyframes heartExplode {
  0% {
    opacity: 1;
    transform: rotate(45deg) translate(0, 0) scale(1);
  }
  100% {
    opacity: 0;
    transform: rotate(45deg) 
               translate(
                 calc(cos(var(--angle)) * var(--distance)), 
                 calc(sin(var(--angle)) * var(--distance))
               ) 
               scale(0);
  }
}

@keyframes nameFloat {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-20px);
  }
}

.heart-container {
  display: inline-block;
}

</style>


// WEBPACK FOOTER //
// src/LeaveManagement/LeaveManagement.vue